module.exports = __webpack_public_path__ + "img/zhaoshang_meiti@2x.17811b33.png";